// extracted by mini-css-extract-plugin
export default {"notificationWrapper":"Notification_notificationWrapper__U0mII","notificationIcon":"Notification_notificationIcon__b6GB3"};